export default {
      id: "pencil-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#pencil-usage",
      toString: function () {
        return this.url;
      }
    }